var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 53,
    viewBox: "0 0 98 53",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.811h0l1.1 4.15 1.343.401-1.1.268-.854 12.716 2.442 4.82H5.52l-.61 1.873 3.053 5.355 3.175 1.204 2.565 3.08 3.787-.402 6.35 2.81 7.573-1.07 4.52 5.354 3.541-1.339 4.153 6.56 3.298 1.204-.367-3.748 3.42-2.275.367-1.74h5.007l4.275 1.338.122-2.142-1.71-.267 3.664-.134.122-1.071.367 1.338 6.717.402 1.832 1.874.245 3.213L73.183 52l1.344-.134.488-3.346-2.198-7.764 1.343-3.213 8.428-6.291-1.588-.67 1.466-.267-1.222-2.008.367-1.874-1.71-1.339 1.71.938L81 23.756l1.221-.67.245 4.953 1.221-2.945-.733-2.275.855 1.338 1.71-4.015 6.718-1.74-1.71-1.205 1.221-3.079 5.13-2.275.122-1.205-1.221-1.071V6.622l-2.81-.937-2.076 4.819-8.427 1.74-.611 2.142-4.885.803.366.67-4.886 2.944-2.076-.134-.122-.803.366-.937.489-.67.244-.802-.733-2.276-1.71.937.611-3.614-2.565-.937L65 11.843 64.267 18l-1.588.134-.488-2.811 1.221-4.685-1.099.803 2.076-2.41 4.397-.133-.733-1.205h-.366l-6.473-.67 1.099-1.472-4.03 2.008h-3.054l3.786-3.213-7.939-1.74L50.1 1l-.122 1.07H4.053l.978 2.009-1.1 1.606.367-1.74L1 3.81",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUs);
export default __webpack_public_path__ + "static/media/us.abf02837665a4c31df4e0c10daa60f5e.svg";
export { ForwardRef as ReactComponent };